module.exports = __webpack_public_path__ + "scenario.3127dc48b901bc747e85fca38141fedb.png";